import { store } from './index'

class StoreManager {
  private static instance: StoreManager;

  private constructor() {}

  public static getInstance(): StoreManager {
    if (!StoreManager.instance) {
      StoreManager.instance = new StoreManager();
    }
    return StoreManager.instance;
  }

  public getIsGlobalEnabled(): boolean {
    return store.getState().globalModel.isGlobalEnabled ?? true;
  }
}

export const storeManager = StoreManager.getInstance();
